class ProductGridGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.gallery = this.querySelector('.grid-product__gallery');
    this.arrows = this.querySelectorAll('.grid-product__arrow');
    this.progressBar = this.querySelector('.grid-product__progress-bar');
    this.indicator = this.querySelector('.grid-product__progress-indicator');
    
    if (!this.gallery) return;

    this.init();
    this.addListeners();
  }

  init() {
    this.updateProgress();
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
  }

  addListeners() {
    this.gallery.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => this.updateProgress());
    }, { passive: true });

    this.arrows.forEach(arrow => {
      arrow.addEventListener('click', (e) => this.onArrowClick(e));
    });
    
    // update on resize
    window.addEventListener('resize', () => {
         window.requestAnimationFrame(() => this.updateProgress());
    });

    // Drag logic removed to restrict to arrow-only navigation on desktop
  }

  onArrowClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    const item = this.gallery.querySelector('.grid-product__gallery-item');
    if(!item) return;

    const itemWidth = item.offsetWidth;
    
    if (btn.classList.contains('grid-product__arrow--next')) {
      this.gallery.scrollBy({ left: itemWidth, behavior: 'smooth' });
    } else {
      this.gallery.scrollBy({ left: -itemWidth, behavior: 'smooth' });
    }
    
    // Explicitly update progress after programmatic scroll
    setTimeout(() => this.updateProgress(), 300);
  }

  updateProgress() {
    if (!this.indicator) return;

    const item = this.gallery.querySelector('.grid-product__gallery-item');
    if(!item) return;

    const scrollLeft = this.gallery.scrollLeft;
    const totalWidth = this.gallery.scrollWidth;
    const clientWidth = this.gallery.clientWidth;
    const itemsCount = this.gallery.querySelectorAll('.grid-product__gallery-item').length;
    
    if(itemsCount <= 1) {
        this.indicator.style.width = '100%';
        this.indicator.style.marginLeft = '0';
        return;
    }

    // Indicator width
    const indicatorWidth = 100 / itemsCount;
    this.indicator.style.width = `${indicatorWidth}%`;
    
    // Position
    const maxScroll = totalWidth - clientWidth;
    
    if (maxScroll > 0) {
       // Clamp scrollLeft to bounds
       const currentScroll = Math.max(0, Math.min(scrollLeft, maxScroll));
       const scrollPercentage = currentScroll / maxScroll;
       
       // Calculate strictly within bounds:
       // The indicator needs to move from 0% left to (100% - indicatorWidth%) left.
       const maxTranslate = 100 - indicatorWidth;
       const currentTranslate = scrollPercentage * maxTranslate;
       
       this.indicator.style.marginLeft = `${currentTranslate}%`;
    } else {
       this.indicator.style.marginLeft = '0';
    }
  }
}

customElements.define('product-grid-gallery', ProductGridGallery);
